import React, { useRef, useState } from 'react'
import { AddIcon, Arrow, CalculatorIcon, CalenderIcon, DeleteIcon } from '../../Images/svgs'
import DropDown from '../Partials/DropDown';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDropdown, setSelectedValue } from '../../Managment/Slice';
import axios from 'axios';

function StockZaka() {
    const [feed, setFeed] = useState([{ name: '', value: '' }]);
    const [TotalValue, setTotalValue] = useState(null);
    const [Error, setError] = useState(null);
    const [goldPrice, setGoldPrice] = useState(67);
    const [nisabReached, setNisabReached] = useState(null);
    const [nisabPrice, setnisabPrice] = useState(null)
    const [showWarning, setShowWarning] = useState(false);
    const [result, setResult] = useState(null);
    const [cooldown, setCooldown] = useState(false);

    const inputRefs = useRef([]);

    const handleChange = (index, name, value) => {
        const newFeed = [...feed];
        newFeed[index] = { name, value };
        setFeed(newFeed);
    };

    const HandleAddMoreInputs = () => {
        const newFeed = [...feed];
        newFeed.push(feed.length + 1);
        setFeed(newFeed);
    }


    const HandleRemoveMoreInputs = () => {
        if (feed.length > 1) {
            const newFeed = [...feed];
            newFeed.pop();
            setFeed(newFeed);
        }
    }


    const dispatch = useDispatch();
    const showlists = useSelector(state => state.dropdown.showlists);
    const selectedValues = useSelector(state => state.dropdown.selectedValues);

    const toggleDropDown = (index) => {
        dispatch(toggleDropdown({ index }));
    };

    const handleSelect = (value, index) => {
        dispatch(setSelectedValue({ index, value }));
    };


    const year = [
        { text: 'ميلادي' },
        { text: 'هجري' }

    ];


    async function makeRequests() {
        const apiKey = 'fmicBXXuhOfNmdPM2pi7jaKefQW9TuWT';
        const startDate = '2023-03-13';
        const endDate = '2023-03-13';
        const requests = [];

        for (const item of feed) {
            const symbol = item.name;
            const url = `https://api.polygon.io/v2/aggs/ticker/${symbol}/range/1/day/${startDate}/${endDate}?apiKey=${apiKey}`;

            const request = axios.get(url)
                .then(response => {
                    const price = response.data.results[0].c;
                    const value = parseFloat(item.value);
                    const totalPrice = price * value;
                    console.log(`Price for ${symbol}:`, price);
                    console.log(`Value for ${symbol}:`, value);
                    console.log(`Total price for ${symbol}:`, totalPrice);
                    return totalPrice;
                })
                .catch(error => {
                    setError(`السهم (${symbol}) غير موجود`)
                    throw error;
                });

            requests.push(request);
        }

        try {
            const responses = await Promise.all(requests);
            const total = responses.reduce((acc, curr) => acc + curr, 0);
            setTotalValue(total);
            calculateResult(total)
        } catch (error) {
            throw error;
        }
    }



    const handleStock = () => {
        setCooldown(true);
        setTimeout(() => {
            setCooldown(false);
        }, 60000);

        setError(null)
        makeRequests()
            .then(data => { })
            .catch(error => { });
    }



    const calculateResult = (total) => {
        if (!total) {
            setShowWarning(true);
            return;
        }

        if (goldPrice && total) {
            const nisab = goldPrice * 87.5
            setnisabPrice(nisab)
            if (total >= nisab) {
                setNisabReached(true)
            } else {
                setNisabReached(false)
            }
        }


        if (selectedValues[0] === 'ميلادي') {
            const calculatedResult = (total * 2.577) / 100;
            setResult(calculatedResult);

        } else {
            const calculatedResult = (total * 2.5) / 100;
            setResult(calculatedResult);
        }

    }



    return (
        <>
            <div className="justify-end">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                    <div className="flex flex-col ml-5 w-[67%] max-md:ml-0 max-md:w-full">
                        <div className="flex flex-col grow px-5 py-10 w-full text-sm bg-white rounded-lg border border-solid border-black border-opacity-20 max-md:mt-5 max-md:max-w-full">
                            <div className="self-start text-base font-medium whitespace-nowrap text-slate-700">
                                اختر السنة
                            </div>
                            <div className="relative flex gap-2 justify-between px-3.5 py-2.5 mt-1.5 font-medium leading-6 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-zinc-600 max-md:flex-wrap max-md:max-w-full">
                                <input className='outline-none grow max-md:max-w-full'
                                    onClick={() => toggleDropDown(5)}
                                    value={selectedValues[0]}
                                    readOnly
                                    placeholder="هجري" />
                                <Arrow className="my-auto w-5 aspect-square" />
                                <DropDown links={year} isOpen={showlists[5]} onSelect={(value) => handleSelect(value, 0)} dropdownId={5} />
                            </div>
                            <div className="flex gap-2 justify-between px-3.5 py-2.5 mt-10 leading-6 text-right rounded-lg border border-gray-300 border-solid shadow-sm bg-stone-50 max-md:flex-wrap max-md:max-w-full">
                                <div className="grow text-gray-500 max-md:max-w-full">
                                    نسبة الزكاة حسب السنة التي قمت بإختيارها
                                </div>
                                <div className="font-bold text-blue-900">{selectedValues[0] === 'ميلادي' ? '0.0275%' : '2.5%'}</div>
                            </div>
                            <div className="self-start mt-10 text-base font-medium text-slate-700">
                                الشركة
                            </div>
                            <div className="flex flex-col gap-1.5 mt-1.5">
                                {Error &&
                                    <div className="flex flex-col bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                                        <span className="block sm:inline text-lg font-bold">{Error}</span>
                                    </div>
                                }
                                {feed.map((filteredItem, index) => (
                                    <div key={index} className='flex flex-row w-full gap-1.5 justify-end font-medium leading-6 text-right whitespace-nowrap text-zinc-600 max-md:flex-wrap max-md:max-w-full'>
                                        <input
                                            ref={(element) => (inputRefs.current[index] = element)}
                                            className="grow justify-center outline-none text-black px-3.5 py-2.5 bg-white rounded-lg border border-gray-300 border-solid shadow-sm"
                                            placeholder="كود سهم الشركة"
                                            value={filteredItem.name}
                                            onChange={(e) => handleChange(index, e.target.value, filteredItem.value)}
                                        />
                                        <input
                                            ref={(element) => (inputRefs.current[index + feed.length] = element)}
                                            className="grow justify-center outline-none text-black px-3.5 py-2.5 bg-white rounded-lg border border-gray-300 border-solid shadow-sm"
                                            placeholder="عدد الأسهم"
                                            value={filteredItem.value}
                                            onChange={(e) => handleChange(index, filteredItem.name, e.target.value)}
                                        />
                                        <button onClick={HandleRemoveMoreInputs} className='flex self-center'>
                                            <DeleteIcon />
                                        </button>
                                    </div>
                                ))}
                                <button onClick={HandleAddMoreInputs} className='flex items-center justify-center'>
                                    <AddIcon className="w-auto h-6 sm:h-8 aspect-square" />
                                </button>
                            </div>
                            <button onClick={handleStock} disabled={cooldown} className={`justify-center self-start px-3.5 py-2 mt-10 font-medium whitespace-nowrap ${cooldown ? 'bg-gray-400 text-white' : 'bg-amber-300 text-neutral-900'} rounded-lg shadow-sm leading-[143%]`}>
                                {cooldown ? 'إنتظر دقيقة' : 'احسب قيمة الزكاة'}
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
                        {result &&
                            <div className="flex flex-col px-5 py-10 mx-auto w-full rounded-2xl border border-solid bg-emerald-300 bg-opacity-20 border-[color:var(--Main-Colors-4,#54E8B2)] max-md:mt-5">
                                <CalculatorIcon
                                    className="self-end aspect-square w-[54px]"
                                />
                                <div className="mt-3 text-sm font-bold leading-6 text-right whitespace-nowrap text-neutral-900">
                                    قيمة الزكاة المراد اخراجها هي
                                </div>
                                <div className="mt-3 text-2xl font-bold leading-5 text-right text-black whitespace-nowrap">
                                    {Math.ceil(result)}
                                </div>
                                <div className="flex gap-3 pl-20 mt-10 max-md:pl-5">
                                    <button className="justify-center px-3.5 py-2 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                                        اخرج زكاتك الان
                                    </button>
                                    <button className="flex justify-center items-center px-3.5 py-2 bg-blue-600 rounded-lg shadow-sm aspect-[1.33]">
                                        <CalenderIcon
                                            className="w-5 aspect-square"
                                        />
                                    </button>
                                </div>
                            </div>
                        }

                    </div>

                </div>
            </div>
        </>
    )
}

export default StockZaka